export default __webpack_public_path__ + "static/media/assignment-list.1b222fbe.svg";